import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, mediaUrl } from "@/lib/api";
import { ProviderFilters } from "@/components/ProviderFilters";
import { useAuth } from "@/context/AuthContext";
import { Star, MapPin, Lock, BadgeCheck } from "lucide-react";
import { ResultsMap } from "@/components/ResultsMap";

export default function Suppliers() {
  const { user } = useAuth();
  const [items, setItems] = useState(null);
  const [filters, setFilters] = useState({});
  const [place, setPlace] = useState(null);
  useEffect(() => { api.get("/suppliers", { params: filters }).then((r)=>setItems(r.data)); }, [filters]);
  return (
    <div className="max-w-7xl mx-auto px-6 py-12">
      <span className="overline text-gold">Directory fornitori</span>
      <h1 className="font-display text-4xl font-bold mt-2 mb-2">Fornitori di Servizi per Eventi</h1>
      <p className="text-slate-600 mb-10">Service audio/luci, palchi, transenne, generatori, effetti speciali e molto altro.</p>
      {!user && <div className="mb-8 p-4 rounded-xl border border-gold/30 bg-gold/5 flex items-center gap-3 text-sm"><Lock className="w-4 h-4 text-gold"/><span>Accedi per vedere prezzi e contatti.</span></div>}
      <ProviderFilters onApply={(p, pl) => { setFilters(p); setPlace(pl); }} />
      {place && items && <ResultsMap place={place} items={items} />}
      {items !== null && items.length===0 && <div className="card-premium p-8 text-center text-slate-500 text-sm" data-testid="no-results">Nessun fornitore corrisponde ai filtri selezionati.</div>}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {(items || []).map((s)=>(
          <Link key={s.id} to={`/artista/${s.id}`} data-testid={`supplier-card-${s.id}`} className="card-premium overflow-hidden">
            <div className="aspect-[4/3] relative">
              <img src={mediaUrl(s.media?.photos?.[0]) || "https://images.pexels.com/photos/14636315/pexels-photo-14636315.jpeg?w=600"} alt={s.companyName} className="w-full h-full object-cover"/>
              <div className="absolute inset-0 bg-gradient-to-t from-navy/70 to-transparent"/>
              <div className="absolute bottom-4 left-4 right-4 text-white">
                <div className="font-display text-xl font-bold flex items-center gap-1.5">{s.companyName}{s.mepaEnabled && <span data-testid={`mepa-${s.id}`} className="inline-flex items-center gap-1 text-[10px] font-bold px-2 py-0.5 rounded-full bg-[#0B5394] text-white shrink-0">MePA</span>}</div>
                <div className="text-xs flex items-center gap-1 mt-1"><MapPin className="w-3 h-3"/>{s.baseLocation}{s.distanceKm !== null && s.distanceKm !== undefined && <span data-testid={`distance-${s.id}`} className="ml-1 text-gold font-semibold">· a {s.distanceKm} km</span>}</div>
              </div>
            </div>
            <div className="p-5">
              <div className="flex flex-wrap gap-1.5 mb-3">{(s.categories?.length ? s.categories : [s.macroCategory]).filter(Boolean).slice(0,3).map((d,i)=><span key={i} className="chip-navy">{d}</span>)}</div>
              <div className="flex items-center justify-between text-sm">
                {s.rating ? <span className="flex items-center gap-1 text-gold font-semibold"><Star className="w-4 h-4 fill-gold"/>{s.rating?.toFixed(1)}</span> : <span className="text-slate-400 text-xs">—</span>}
                {s.baseFeeNet ? <span className="font-display text-lg font-bold">€{s.baseFeeNet?.toFixed(0)}<span className="text-xs text-slate-500 font-normal">/base</span></span> : <span className="chip-navy"><Lock className="w-3 h-3"/>Riservato</span>}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
